<template>
  <form @submit.prevent="$emit('onEvent', data)">
    <app-model :class="{ 'show': show }">
      <template v-slot:header class="modal-header d-flex align-items-center">
        <h4 class="card-title mb-0">Nuevo registro</h4>
        <button type="button" @click="onClose()" class="btn-close"></button>
      </template>
      <template v-slot:body class="modal-body">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="control-label">Nombre</label>
              <input type="text" v-model="data.first_name" name="first_name" class="form-control" placeholder="Example" />
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label class="control-label">Apellido</label>
              <input type="text" v-model="data.last_name" name="last_name" class="form-control" placeholder="Example" />
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label class="control-label">Correo electrónico</label>
              <input type="email" v-model="data.email" name="email" class="form-control" placeholder="test@example.com" />
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label class="control-label">Teléfono</label>
              <input type="text" v-model="data.phone" name="phone" class="form-control" placeholder="+502 12345678" />
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label class="control-label">Contraseña</label>
              <input type="password" v-model="data.password" name="password" class="form-control" placeholder="Contraseña" />
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer class="modal-footer">
        <button type="submit" class="btn btn-success rounded-pill px-4">
          <span v-if="submit" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span :class="{ 'visually-hidden' : submit}">
            <i class="ti ti-device-floppy me-1 fs-4"></i> Guardar
          </span>
        </button>
        <button type="button" @click="onClose()" class="btn btn-danger rounded-pill px-4 ms-2 text-white">Cancelar</button>
      </template>
    </app-model>
  </form>
</template>
<script>
export default {
  props: {
    id: {
      type: String | Number,
      default: null
    },
    submit: {
      type: Boolean,
      default: false
    },
    onEvent: {
      type: Function,
      default: () => { console.log('aca') }
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      show: false
    }
  },
  created () {
    setInterval(() => {
      if (this.id) {
        this.show = true
      }
    }, 100)
  },
  methods: {
    onClose: function () {
      this.show = false
      this.$emit('onClose')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/models/Create.vue